export enum ResourceBase {
  Database = 0,
  Filebase = 1
}
